// extracted by mini-css-extract-plugin
export var iframe = "iframeEmbed-module--iframe--1MIfg";
export var iframeWrapper = "iframeEmbed-module--iframeWrapper--ljnts";
export var sbShowMain = "iframeEmbed-module--sb-show-main--znGGS";